import ReactDOM from 'react-dom/client';
import App from './App';
import { clearPortalAuthStorage } from './utils/loginUtils';
import './i18n';

// ── Build-version guard ───────────────────────────────────────────────────────
// REACT_APP_BUILD_VERSION is stamped at Docker build time (epoch timestamp).
// If the stored value differs from the current build, the user has a stale
// frontend: clear auth data and send them back to login so they pick up the
// fresh assets automatically.
const BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION;
if (BUILD_VERSION) {
  const stored = localStorage.getItem('appVersion');
  if (stored !== BUILD_VERSION) {
    clearPortalAuthStorage();
    localStorage.setItem('appVersion', BUILD_VERSION);
    if (!window.location.pathname.startsWith('/auth')) {
      window.location.replace('/auth/login');
    }
  }
}
// ─────────────────────────────────────────────────────────────────────────────

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
